<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ep">In Hebrew, <em class="i">perfect</em> means “whole or complete.” It is God’s desire for our lives that we become perfect or whole in Him. He is slowly revealing His perfect secret for each of our lives.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// APerfectSecreteBook6.vue?7afc55ac